import { action, makeObservable, observable } from "mobx";
import { INFT } from "../../../entities/NFT/NFTTypes";
import BaseModalOperationsStore from "../../common/BaseModalOperationsStore";

export enum CartModalType {
  transactionPending = "transaction_pending",
  transactionSuccess = "transaction_success",
  transactionError = "transaction_error",
}

class UserCartStore extends BaseModalOperationsStore<CartModalType> {
  cart: INFT[] = [];
  purchasedNFTs: INFT[] = [];

  constructor(private readonly userAddress: string) {
    super(CartModalType.transactionPending);
    makeObservable<UserCartStore>(this, {
      cart: observable,
      purchasedNFTs: observable,

      addItemToPurchased: action,
      resetPurchasedNFTs: action,
      addItemToCart: action,
      removeItemFromCart: action,
      resetCart: action,

      // purchaseCartItemsFlow: flow,
    });
  }

  addItemToCart(item: INFT) {
    this.cart.push(item);
  }

  addItemToPurchased(item: INFT) {
    this.purchasedNFTs.push(item);
  }

  resetPurchasedNFTs() {
    this.purchasedNFTs = [];
  }

  removeItemFromCart(address: string) {
    this.cart = this.cart.filter((cartItem) => cartItem.address !== address);
  }

  resetCart() {
    this.cart = [];
  }

  resetModalFlow() {
    this.isModalVisible = false;
    this.cart = [];
    this.currentModal = CartModalType.transactionPending;
  }

  isInCart(address: string) {
    return this.cart.some((cartItem) => cartItem.address === address);
  }
}

export default UserCartStore;
